import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../../utils/constants';
import CommentThread from './comment-thread/CommentThread';

// Types for mock data
export type Author = {
  name: string;
  badge?: string | null;
  timeAgo: string;
  avatar: { initials: string; backgroundColor: string };
};

export type Response = {
  id: string;
  content: string;
  author: Author;
  created_at: string;
  is_solution: boolean;
  is_edited: boolean;
  edited_at: string | null;
  order: number;
  is_spam: boolean;
  parent_responseid?: string | null;
  responses: Response[];
};

interface Props {
  responses: Response[];
  postId: string;
}

function CommentsSection({ responses, postId }: Props) {
  // Filter out responses that have a parent_response_id (nested responses)
  const topLevelResponses = responses.filter((response) => !response.parent_responseid);

  if (topLevelResponses.length === 0) {
    return null;
  }

  return (
    <section css={sectionStyles}>
      <h2 css={headingStyles}>Answers</h2>
      {topLevelResponses.map((response) => (
        <CommentThread key={response.id} response={response} replyInputDepth={1} postId={postId} />
      ))}
    </section>
  );
}

const sectionStyles = css({
  marginTop: '40px',
  [MOBILE.MEDIA_QUERY]: {
    marginTop: '24px',
  },
});

const headingStyles = css({
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '1.4',
  margin: '0 0 16px 0',
  color: token('color.text'),
  fontFamily: 'Charlie Text, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '20px',
    marginBottom: '12px',
  },
});

export default CommentsSection;
